import { render, staticRenderFns } from "./VStage.vue?vue&type=template&id=1a88f5b6&"
import script from "./VStage.vue?vue&type=script&lang=js&"
export * from "./VStage.vue?vue&type=script&lang=js&"
import style0 from "./VStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports